import React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgRteLink = function SvgRteLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.968 19a3.943 3.943 0 01-2.807-1.163 3.972 3.972 0 010-5.612l1.72-1.719a.874.874 0 111.237 1.238l-1.72 1.718a2.222 2.222 0 000 3.138c.841.839 2.302.838 3.139 0l1.72-1.719a.875.875 0 111.238 1.238l-1.72 1.718A3.94 3.94 0 018.968 19zm6.534-5.25a.874.874 0 01-.619-1.494l1.72-1.718a2.222 2.222 0 000-3.138c-.84-.839-2.302-.837-3.138 0l-1.72 1.719a.875.875 0 11-1.239-1.238l1.72-1.718A3.94 3.94 0 0115.034 5c1.06 0 2.058.413 2.807 1.163a3.973 3.973 0 010 5.612l-1.72 1.719a.873.873 0 01-.618.256zm-5.252.875a.874.874 0 01-.619-1.494l3.501-3.5a.875.875 0 111.238 1.238l-3.5 3.5a.874.874 0 01-.62.256z"
  })));
};
var rteLink = SvgRteLink;

export { rteLink as default };
